// Which Invoice Date a user may give an inspector invoice. Finance can use any
// date; everyone else gets one open month: from the 1st to the 5th that's LAST
// month, from the 6th it's the CURRENT month (last month is locked) — never later
// than today. "Today" is taken in IST. Mirrors backend/utils/invoiceDateWindow.js —
// the server enforces the same rule.

const UNRESTRICTED_ROLES = ['finance'];
export const INVOICE_DATE_CUTOFF_DAY = 5;

const pad = (n) => String(n).padStart(2, '0');

function todayIST(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}

const monthLabelOf = (y, m) =>
  new Date(Date.UTC(y, m - 1, 1)).toLocaleString('en-IN', { month: 'long', year: 'numeric', timeZone: 'UTC' });

// null = no restriction, else { from, to, monthLabel, hint } — from/to YYYY-MM-DD inclusive.
export function invoiceDateWindow(role, now = new Date()) {
  if (UNRESTRICTED_ROLES.includes(role)) return null;
  const today = todayIST(now);
  const [y, m, d] = today.split('-').map(Number);
  if (d <= INVOICE_DATE_CUTOFF_DAY) {
    const prevY = m === 1 ? y - 1 : y;
    const prevM = m === 1 ? 12 : m - 1;
    const lastDay = new Date(Date.UTC(prevY, prevM, 0)).getUTCDate();
    const monthLabel = monthLabelOf(prevY, prevM);
    const cutoff = `${INVOICE_DATE_CUTOFF_DAY} ${new Date(Date.UTC(y, m - 1, 1)).toLocaleString('en-IN', { month: 'short', timeZone: 'UTC' })}`;
    return {
      from: `${prevY}-${pad(prevM)}-01`, to: `${prevY}-${pad(prevM)}-${pad(lastDay)}`, monthLabel,
      hint: `Invoice Date must be in ${monthLabel} (open until ${cutoff}).`,
    };
  }
  const monthLabel = monthLabelOf(y, m);
  const prevLabel = monthLabelOf(m === 1 ? y - 1 : y, m === 1 ? 12 : m - 1);
  return {
    from: `${y}-${pad(m)}-01`, to: today, monthLabel,
    hint: `Invoice Date must be in ${monthLabel}, up to today. ${prevLabel} is locked — contact Finance.`,
  };
}

export function isDateInWindow(dateStr, window) {
  if (!window) return true;
  const d = String(dateStr || '').slice(0, 10);
  return d >= window.from && d <= window.to;
}
